import React,{ useState} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { Divider, Modal, Loader, Button  } from 'rsuite';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import * as actionsPayment  from '../../../../app/actions/payment';
import {BackIcon} from '../svg/iconsSvg';

export const ProfilePayCards = ({onBack, style}) => {

    const dispatch = useDispatch();

     const { paymentCards } = useSelector(state => state.payment);
    //const paymentCards = [1, 2]

    const [confirmDeleteModal, setConfirmDeleteModal] = useState({open: false, cardId: null});

    const [loading, setLoading] = useState(false);

    const goBack = () => onBack(3);

    const closeModal = () => {
        setConfirmDeleteModal({open: false, cardId: null})
    }

    const askToDeleteCard = (event, cardId) => {
        setConfirmDeleteModal({open: true, cardId: cardId})
    }

    const deletePayCard = async (cardId) => {
        setConfirmDeleteModal({open: false, cardId: null});
        setLoading(true);
        await dispatch(actionsPayment.deletePaymentCard(cardId));
        setLoading(false);
    }

    const renderPaymentCards = () => {
        return paymentCards.map((card, i) => {
            return  (<div key={i+1} className="profile-pay-card">
                <div className="card">
                    <p>{card?.maskedPan}</p>
                    <p>{card?.expiryDate}</p>
                </div>
                <DeleteForeverOutlinedIcon className="icon" onClick={(event)=>askToDeleteCard(event, card?.cardId)} />
            </div>
            )
        })
    }

    return ( <>
        <div className="steps_container" style={style}>
            <div className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Профил</h6>
            </div>
            <Divider style={{marginBottom: 0}}/>
            {renderPaymentCards()}

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}
        </div>

        {/* Modal */}
        <Modal size="xs" show={confirmDeleteModal.open} onHide={() => closeModal()} className="delivery-modal">
            <Modal.Header>
                <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingBottom: '2rem'}}>
                <p className="no-reg-data" style={{textAlign: 'center'}}>Искаш ли да изтриеш картата?</p>    
            </Modal.Body>
            <Divider style={{margin: 0}} />
            <Modal.Footer className='delivery-modal-buttons'>
                <Button appearance="subtle" onClick={() => closeModal()} >НЕ</Button>
                <Button appearance="subtle" onClick={() => deletePayCard(confirmDeleteModal.cardId)} style={{marginLeft: 0}}>Да, изтрий</Button>
            </Modal.Footer>
        </Modal>
    </>
    )
}

export default ProfilePayCards;